import { formatCheckInPositionDate } from "components/events/helpers/check-in-position-date-helper";


const LOCATION_FIELDS = [ "latitude", "longitude", "radius", "country", "address" ];
const timestamp = (value) => typeof value === "string" ? value.trim() : "";
const text = (value) => typeof value === "string" ? value.trim() : "";
const matchesEvent = (event, log) => Boolean(log && event?.id && (
    log.ee_id === null || log.ee_id === undefined || String(log.ee_id) === String(event.id)
));

export const getStaffCheckInProvenance = (event, kind) => {
    const isQr = kind === "qr";
    const candidate = isQr ? event?.getCheckinLogQrSet : event?.getCheckinLogLast;
    const generatedAt = timestamp(event?.check_qr_generated_at);
    const validRecord = matchesEvent(event, candidate) && (isQr ?
        Boolean(formatCheckInPositionDate(generatedAt)) &&
            timestamp(candidate.new_qr_generated_at) === generatedAt &&
            timestamp(candidate.old_qr_generated_at) !== generatedAt :
        Array.isArray(candidate.changedFields) && candidate.changedFields.some((field) => (
            typeof field === "string" && LOCATION_FIELDS.includes(field.toLowerCase().replace(/^check_/, ""))
        )));
    const log = validRecord ? candidate : null;
    const dateValue = isQr ? event?.check_qr_generated_at : log?.created_at;

    return {
        actor: [ text(log?.relUser?.name), text(log?.relUser?.surname) ].filter(Boolean).join(" "),
        source: [ "APP", "CRM" ].includes(log?.source) ? log.source : null,
        date: formatCheckInPositionDate(dateValue),
        unavailableDateKey: isQr && !timestamp(dateValue) ?
            "CHECK_QR.Text_GenerationDateNotRecorded" : "CHECK_QR.Text_DateUnavailable",
    };
};
